import { Component } from '@angular/core';
import {
  BaseComponent
} from 'base-form';

@Component({
  selector: 'mfpc-file-uploader',
  templateUrl: './file-uploader.component.html',
  styleUrls: ['./file-uploader.component.scss']
})
export class FileUploaderComponent extends BaseComponent {
  Object = Object;

  fileNames: string[];

  fileProcessing(
    formControlName: string,
    fileDescription: string,
    event: Event,
    loadType: string
  ): void {
    this.fileNames = [];
    const target = event.target as HTMLInputElement;
    const getBase64 = (f: Blob | File): Promise<string | ArrayBuffer> => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(f);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    };

    switch (loadType) {
      case 'base64':
      default: {
        const formControlValue = [];
        for (const ind of Object.keys(target?.files || {})) {
          getBase64(target.files[ind]).then((file64) => {
            const valObj = {};
            const fileName = target.files[ind].name;
            const fileObj = { fileName, file64, fileDescription };
            formControlValue.push(fileObj);
            valObj[formControlName] = formControlValue;
            this.form.patchValue(valObj);
          });
        }
        break;
      }
    }
  }
}
